import { z } from 'zod';

export const connectedCompanyIntegrationsSchema = z.object({
  company: z.array(z.string()),
  own: z.array(z.string()),
});

export type ConnectedCompanyIntegrations = z.infer<typeof connectedCompanyIntegrationsSchema>;
